<template>
    <div>
        <option-header-contract-info
            v-if="dto.headerContractInfo"
            id="header-banner-contract-info"
            :current-contract-label="dto.headerContractInfo.currentContractLabel"
            :contract-selector-page-link-label="dto.headerContractInfo.contractSelectorPageLinkLabel"
            :contract-selector-page-link-url="dto.headerContractInfo.contractSelectorPageLinkUrl"
        />
        <option-banner v-if="dto.bannerTitle" :title="dto.bannerTitle" />
        <div class="option-detail-header">
            <div v-if="dto.visual != null" class="w-100 option-detail-header__img">
                <ob1-picture css-classes="img-fluid w-100" :visual="dto.visual" :lazy-loading="false" />
            </div>
            <div class="option-detail-header-text-block text-white mt-md-2 ms-0 ms-md-2 ms-lg-3">
                <div class="option-detail-header-text py-2">
                    <h1 class="mb-0">
                        {{ dto.shortLabel }}
                    </h1>
                    <h4 class="mb-0">
                        {{ dto.shortDescription }}
                    </h4>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <incentive-authenticate
                v-if="dto.incentiveAuthenticate"
                class="mt-2 mt-md-3 mt-lg-4 mb-1"
                :title="dto.incentiveAuthenticate.question"
                :text="dto.incentiveAuthenticate.message"
                :link-href="getAuthenticateLinkUrl"
                :link-label="dto.incentiveAuthenticate.linkLabel"
            />
            <ob1-message-alerte
                v-if="dto.ineligibilityMessageAlerte"
                class="mt-2 mt-md-3 mt-lg-4 mb-1 mb-md-2"
                :is-simple-alerte="false"
                :type="dto.ineligibilityMessageAlerte.alertType"
                :title="dto.ineligibilityMessageAlerte.title"
                :texts="dto.ineligibilityMessageAlerte.texts"
                :with-link-from-dto="dto.ineligibilityMessageAlerte.link"
            />
        </div>
        <div class="container-fluid">
            <div v-if="dto.salesPitchDto" class="col-12 mt-1 mt-md-2 mb-1 mb-md-2 px-0">
                <sales-pitch :sales-pitch-dto="dto.salesPitchDto" />
            </div>
        </div>
        <div class="margin-key-points container-fluid">
            <key-points v-if="dto.keyPoints.length > 0" :key-points="dto.keyPoints" />
        </div>
        <div class="container-fluid">
            <div v-if="dto.adviceDuty" class="col-12 mt-2 mt-md-3 mt-lg-4 px-0">
                <advice-duty-bloc :advice-duty="dto.adviceDuty" />
            </div>
            <ob1-liens-haut-bas
                v-if="dto.adviceDuty"
                class="col-12 mt-1 mt-lg-2 px-0"
                button-id="simulator-link"
                collapsed-block-id="simulator-block"
                :button-label="dto.simulatorMessages.link"
                :is-large="true"
                :link-classes="'ps-1 ps-md-2 pe-2 bg-greige'"
                @ob1-liens-haut-bas-show-block="handleShowSimulator"
            >
                <simulator
                    class="mt-1 mt-lg-2"
                    :variations="dto.variations"
                    :pre-selected-variation-id="dto.selectedVariationId"
                    :messages="dto.simulatorMessages"
                    :option-label="dto.shortLabel"
                    @input="onInput"
                />
            </ob1-liens-haut-bas>
            <simulator
                v-else
                class="col-12 mt-2 mt-md-3 mt-lg-4 px-0"
                :variations="dto.variations"
                :pre-selected-variation-id="dto.selectedVariationId"
                :messages="dto.simulatorMessages"
                :option-label="dto.shortLabel"
                @input="onInput"
            />
            <div v-if="dto.pushZigZag.zigZagItems.length > 0" class="px-0">
                <div class="mt-2 mt-md-3 mt-lg-4">
                    <header-signature :text="dto.pushZigZag.title" />
                    <push-zig-zag :zigzag="dto.pushZigZag" />
                </div>
            </div>
            <div class="px-0">
                <!--/* Zone FAQ */-->
                <div v-if="dto.faq">
                    <faq
                        :title="dto.faq.title"
                        :question-list="dto.faq.questionList"
                    />
                </div>
            </div>
            <div v-if="dto.contractualDocuments.length > 0" class="px-0">
                <contractual-documents :contractual-documents="dto.contractualDocuments" :web-view="dto.webView" />
            </div>
        </div>
        <div v-if="dto.legalMention" class="px-0 bg-gray2">
            <div class="container-fluid">
                <legal-mentions :legal-mention="dto.legalMention" />
            </div>
        </div>
    </div>
</template>

<script>

import OptionBanner from "./Banner.vue";
import OptionHeaderContractInfo from "./HeaderContractInfo.vue";
import PushZigZag from "../../common/fragments/mobile/PushZigZag.vue";
import KeyPoints from "./KeyPoints.vue";
import IncentiveAuthenticate from "./IncentiveAuthenticate.vue";
import ContractualDocuments from "./ContractualDocuments.vue";
import LegalMentions from "./LegalMentions.vue";
import Simulator from "./Simulator.vue";
import Faq from "../common/fragments/Faq.vue";
import HeaderSignature from "../../common/components/vue/HeaderSignature.vue";
import AdviceDutyBloc from "./AdviceDutyBloc.vue";
import SalesPitch from "./SalesPitch.vue";

export default {
    components: {
        AdviceDutyBloc,
        HeaderSignature,
        Simulator,
        LegalMentions,
        ContractualDocuments,
        IncentiveAuthenticate,
        KeyPoints,
        PushZigZag,
        OptionBanner,
        OptionHeaderContractInfo,
        Faq,
        SalesPitch
    },
    data: function () {
        return {
            dto: dto,
            variationId: dto.selectedVariationId
        }
    },
    computed: {
        getAuthenticateLinkUrl() {
            if (!this.dto.incentiveAuthenticate) {
                return null;
            }
            let authenticateLinkUrl = this.dto.incentiveAuthenticate.linkUrl;
            if (!this.variationId) {
                return authenticateLinkUrl;
            }

            let authenticateReturnUrl = this.getParam(authenticateLinkUrl, "return_url");
            if (this.getParam(authenticateReturnUrl, "variationId") === "") {
                authenticateReturnUrl = addParam(authenticateReturnUrl, "variationId=" + this.variationId);
            } else {
                authenticateReturnUrl = setParam(authenticateReturnUrl, "variationId", this.variationId);
            }
            let encodedReturnUrl = encodeURIComponent(authenticateReturnUrl);

            return setParam(authenticateLinkUrl, "return_url", encodedReturnUrl);
        }
    },
    methods: {
        onInput: function (variationId) {
            this.variationId = variationId;
            this.updateUrlWithVariation();
        },
        updateUrlWithVariation() {
            if (this.getParam(window.location.href, "variationId") === "") {
                window.history.replaceState({}, null, addParam(window.location.href, "variationId=" + this.variationId));
            } else {
                window.history.replaceState({}, null, setParam(window.location.href, "variationId", this.variationId));
            }
        },
        getParam: function (url, paramName) {
            let param = getParameterByName(paramName, url);
            if (!param) {
                param = "";
            }
            return param;
        },
        handleShowSimulator() {
            Tms.link({category: "afficher_assurance", action: "lien_deroulant", label: "deplier"})
        }
    }
}
</script>

<style lang="scss" scoped>
@import 'ob1_variables';

@media (max-width: #{map-get($grid-breakpoints, md)}) {
    .margin-key-points {
        margin: 0;
        padding: 0;
    }
    .option-detail-header__img {
        width: 100%;
        aspect-ratio: 32 / 23;
    }

    .option-detail-header-text {
        padding-left: 15px;
        padding-right: 15px;
    }
}

@media (min-width: #{map-get($grid-breakpoints, md)}) {
    .option-detail-header {
        display: flex;
        position: relative;
        width: 100%;
    }
    .option-detail-header__img {
        aspect-ratio: 16 / 9;
    }
    .option-detail-header-text-block {
        position: absolute;
        display: flex;
        width: 53%;
        min-height: calc(100% - 30px);
    }

    .option-detail-header-text {
        padding-left: 30px;
        padding-right: 30px;
    }
}

@media (min-width: #{map-get($grid-breakpoints, lg)}) {
    .option-detail-header {
        display: flex;
        position: relative;
        width: 100%
    }
    .option-detail-header__img {
        aspect-ratio: 960 / 498;
    }
    .option-detail-header-text-block {
        position: absolute;
        display: flex;
        width: 35.6%;
        min-height: calc(100% - 30px);
    }
    .option-detail-header-text {
        padding-left: 55px;
        padding-right: 55px;
    }
}

@media (min-width: #{map-get($grid-breakpoints, xl)}) {
    .option-detail-header__img {
        aspect-ratio: 1200 / 459;
    }
}

@media (min-width: #{map-get($grid-breakpoints, xxl)}) {
    .option-detail-header__img {
        aspect-ratio: 1440 / 553;
    }
}

.orange {
    .option-detail-header-text-block {
        background-color: black;
    }
}

.sosh {
    .option-detail-header-text-block {
        background-color: rgb(38, 130, 142);
    }
}


</style>

<style lang="scss">
@import 'ob1_variables';

@media (min-width: #{map-get($grid-breakpoints, md)}) {
    .max-width-bloc {
        max-width: 450px;
    }
}
</style>
